import React from 'react'

const Features = () => {
    return (
        <>
            {/* feature container start */}
            { /* feature heading container start */ } 
            <div className = "order-2 lg:order-1 w-full lg:w-4/6 mb-4" >
                <h4 className = "feature-heading-m1" >
                    Flexible
                </h4> 
            </div> 
            { /* feature heading container end */ }

    {/****************************************(1)****************************************************/}
            
            <div className="flex flex-wrap lg:flex-nowrap items-center mb-5">
                
                {/* feature text container start */}
                <div className="order-2 lg:order-1 w-full lg:w-1/1">
                    <p className = "feature-p-text pr-10">
                        The flexible design of the Carbomedics AnnuloFlex<sup>TM </sup> 
                        Annuloplasty System provides implant versatility to accommodate 
                        surgeon preference and various clinical indications.<sup>1-3</sup>
                        <br/>
                        <br/>
                        Three-in-one prosthesis easily converts from mitral ring to mitral 
                        band or tricuspid band, thanks to two suture cut points.

                    </p>

                </div>
                {/* feature text container end */}
            </div>
            {/* feature container end */}
            {/* feature image container start */}
            <div className=" w-full lg:w-1/1">
                <ul className = "pl-4 md:pl-0 feature-p-text list-disc lg:px-5 feature-p-text mb-10">
                    <li>Reduces hospital inventory.</li>
                    <li>Full flexibility delivers three-dimensional compliance that mirrors natural valve dynamics.<sup>2</sup>
                    </li>
                    <li>
                        Ring constructed with internal size 1 suture along with 
                        four knots, designed to reduce 
                        post-implantation dilatation.<sup>1</sup>
                    </li>
                    <li>Barium-impregnated silicone facilitates radiographic visualization.</li>

                    </ul>
            </div>
            {/* feature image container end */}

    {/*************************************(2)************************************************/}    

        <div className = "md:w-1/2 mb-40">
            <img src = "/images/annuloflex/Flexible.png" alt="Flexible" />
            <div className = "flex flex-wrap md:flex-nowrap mt-20">
                <p className = "feature-p-text w-full md:w-1/3 mb-4">
                    Attachments between anterior and posterior segments tested to 
                    exceed tensile failure loads of 6.0 lbf (pounds - force)
                </p>
                <img className = "" src = "/images/annuloflex/Flexible2.png" alt="Flexible" />

            </div>
            
        </div>

        </>
    )
}

export default Features
